module.exports = __webpack_public_path__ + "img/chair-office.54bcbb74.svg";